import React from 'react';

export function fmtEUR(cents) {
  return ((cents || 0) / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
}

export function fmtDate(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short', year: 'numeric' });
}

export const STATUS_BADGE = {
  scheduled: { label: 'Planifiée', cls: 'bg-slate-100 text-slate-700' },
  pending: { label: 'En cours', cls: 'bg-sky-50 text-sky-700' },
  submitted: { label: 'Soumise', cls: 'bg-sky-50 text-sky-700' },
  paid: { label: 'Payée', cls: 'bg-emerald-100 text-emerald-700' },
  failed: { label: 'Échouée', cls: 'bg-rose-100 text-rose-700' },
  cancelled: { label: 'Annulée', cls: 'bg-slate-100 text-slate-500' },
  chargedback: { label: 'Contestée', cls: 'bg-rose-100 text-rose-700' },
  creation_failed: { label: 'Échec création', cls: 'bg-rose-100 text-rose-700' },
};

export const MANDATE_BADGE = {
  active: { label: 'Mandat signé', cls: 'bg-emerald-600 text-white' },
  pending: { label: 'Mandat en attente', cls: 'bg-[#DEA900] text-[#0a3d62]' },
  revoked: { label: 'Mandat révoqué', cls: 'bg-rose-600 text-white' },
};

export function KpiCard({ icon: Icon, label, value, sub, tone = 'navy', testid }) {
  const tones = {
    navy: { bg: 'from-[#0a3d62] to-[#0c4a78]', icon: 'text-[#f5cc3e] bg-white/10' },
    emerald: { bg: 'from-emerald-700 to-emerald-600', icon: 'text-emerald-100 bg-white/15' },
    sky: { bg: 'from-sky-700 to-sky-600', icon: 'text-sky-100 bg-white/15' },
    gold: { bg: 'from-[#b88600] to-[#DEA900]', icon: 'text-amber-50 bg-white/15' },
    indigo: { bg: 'from-indigo-700 to-violet-600', icon: 'text-indigo-100 bg-white/15' },
  };
  const t = tones[tone] || tones.navy;
  return (
    <div
      data-testid={testid}
      className={`relative overflow-hidden rounded-2xl bg-gradient-to-br ${t.bg} p-4 text-white shadow-md hover:shadow-xl transition-shadow`}
    >
      <div className="absolute -right-6 -bottom-6 w-24 h-24 rounded-full bg-white/5" />
      <div className="relative flex items-start gap-3">
        <div className={`h-10 w-10 rounded-xl flex items-center justify-center ${t.icon} backdrop-blur`}>
          <Icon className="h-5 w-5" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] uppercase tracking-wider text-white/70 font-bold">{label}</div>
          <div className="text-2xl font-black tabular-nums mt-0.5 truncate">{value}</div>
          {sub && <div className="text-[10px] text-white/80 mt-0.5 truncate">{sub}</div>}
        </div>
      </div>
    </div>
  );
}
